import { useNavigate } from "@tanstack/react-router";
import { DataTable } from "../../components/DataTable";

const columns = [
  { accessorKey: "no", header: "Return No.", meta: { minWidth: 100 } },
  {
    accessorKey: "returnFromInvoice",
    header: "Invoice No.",
    meta: { minWidth: 100 },
  },
  { accessorKey: "returnRef", header: "Reference", meta: { minWidth: 250 } },
  { accessorKey: "branchName", header: "Branch", meta: { minWidth: 200 } },
  {
    accessorKey: "collectionContact",
    header: "Collection Contact",
    meta: { minWidth: 150 },
  },
  { accessorKey: "postCode", header: "Postcode", meta: { minWidth: 100 } },
];

export const ReturnTable = ({
  data,
  loading,
  returnsFilter,
  setReturnsFilter,
}) => {
  const navigate = useNavigate();

  const returns = data?.completedOrder || [];
  const rowCount = Number(data?.paging?.noOfRecords) || 0;

  const pagination = {
    page: (returnsFilter?.page ?? 1) - 1,
    pageSize: returnsFilter?.pageSize ?? 25,
  };

  const handlePaginationChange = (next) => {
    setReturnsFilter((prevState) => ({
      ...prevState,
      page: next.page + 1,
      pageSize: next.pageSize,
    }));
  };

  return (
    <DataTable
      aria-label="Completed returns"
      columns={columns}
      rows={returns}
      getRowId={(row) => row.no}
      rowCount={rowCount}
      page={pagination.page}
      pageSize={pagination.pageSize}
      loading={loading}
      onPaginationChange={handlePaginationChange}
      onRowClick={(row) => navigate({ to: `/returns/completed/${row.no}` })}
    />
  );
};
